<template>
  <div class="flex gap-1">
    <button
      v-if="includeAll"
      @click="$emit('load-all')"
      :class="[buttonClass, allTime ? activeClass : inactiveClass]"
    >
      All tracked
    </button>
    <button
      v-for="preset in presets"
      :key="preset.key"
      @click="$emit('apply-preset', preset.key)"
      :class="[buttonClass, !allTime && preset.key === activePreset ? activeClass : inactiveClass]"
    >
      {{ preset.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'TimeRangePresetButtons',
  props: {
    presets: { type: Array, default: () => [] },
    activePreset: { type: String, default: '' },
    includeAll: { type: Boolean, default: false },
    allTime: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
  },
  computed: {
    buttonClass() {
      return this.compact ? 'px-2 py-1 rounded border text-xs' : 'px-3 py-2 rounded border text-sm'
    },
    activeClass() { return 'bg-black text-white border-black' },
    inactiveClass() { return 'bg-white hover:bg-gray-50' },
  },
}
</script>
